export { Ratings } from './ratings-v2';
export type { RatingsProps } from './ratings-v2';
